import { render, staticRenderFns } from "./pie.vue?vue&type=template&id=2c2e39d2&scoped=true&"
import script from "./pie.vue?vue&type=script&lang=js&"
export * from "./pie.vue?vue&type=script&lang=js&"
import style0 from "./pie.vue?vue&type=style&index=0&id=2c2e39d2&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2e39d2",
  null
  
)

export default component.exports